import React from 'react';
import {
  Box,
  Alert,
  Button,
  AlertTitle,
  IconButton,
  DeleteIcon,
  AlertDescription,
} from 'ui';
import { TextGroupField } from '@components/FormFields';
import { DocumentFileIcon } from '@assets/icons';
import { ts } from '../../utils';
import { styles as s } from '../../FileUploader.styles';

export const AskForPassword = ({
  control,
  status = 'pending',
  fileNames,
  fieldName,
  onRemoveFile,
  isAlertLoading,
  onSubmitWithPassword,
  ...props
}) => (
  <Alert
    status={status}
    {...s.alert}
    {...s[`alert-${status}`]}
    {...props}
  >
    <Box>
      <DocumentFileIcon color="blue.500" {...s.alertIcon} />
    </Box>
    <AlertTitle {...s.alertTitle}>
      {fileNames}
    </AlertTitle>
    {['pending'].includes(status) && (
      <AlertDescription {...s.alertDescription}>
        <IconButton
          {...s.iconButton}
          onClick={onRemoveFile}
          aria-label={ts('alert.icon')}
          icon={<DeleteIcon color="gray.400" />}
        />
      </AlertDescription>
    )}
    <TextGroupField
      {...s.passwordField}
      type="password"
      control={control}
      name={`${fieldName}-password`}
      labelText={ts('fields.password.label')}
      rightContentWidth="16"
      isDisabled={isAlertLoading}
      autoComplete="new-password"
      rightContent={(
        <Button
          {...s.submitButton}
          type="button"
          isDisabled={isAlertLoading}
          onClick={onSubmitWithPassword}
        >
          Subir
        </Button>
        )}
    />
  </Alert>
);
